import { render, staticRenderFns } from "./kontakt-einstellungen.vue?vue&type=template&id=4cd4b3aa&scoped=true&"
import script from "./kontakt-einstellungen.vue?vue&type=script&lang=js&"
export * from "./kontakt-einstellungen.vue?vue&type=script&lang=js&"
import style0 from "./kontakt-einstellungen.vue?vue&type=style&index=0&id=4cd4b3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4b3aa",
  null
  
)

export default component.exports